import { Component, OnInit, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AinStateComponent } from '../../shared/design-system/state.component';
import { REGULATED_PANEL_STYLES } from './sales-regulated-panel.styles';
import { RegulatedBrokerageAccountListItem, SalesRegulatedApiService } from './sales-regulated-api.service';

@Component({
  standalone: true,
  selector: 'ain-sales-brokerage-accounts',
  imports: [AinPageComponent, AinStateComponent, FormsModule, TableModule, ButtonModule, CheckboxModule, InputTextModule],
  template: `
    <ain-page [title]="t('sales.regulated.brokerage.accountsTitle')" [description]="t('sales.regulated.brokerage.description')">
      @if (loading()) { <ain-state type="loading" [title]="t('common.loading')" /> } @else {
        <section class="panel">
          <div class="toolbar">
            <button pButton type="button" [label]="t('sales.action.create')" (click)="openCreate()"></button>
            <button pButton type="button" [label]="t('sales.regulated.brokerage.ordersNav')" severity="secondary" (click)="goOrders()"></button>
            <button pButton type="button" [label]="t('sales.action.refresh')" severity="secondary" (click)="load()"></button>
          </div>
          <p-table [value]="rows()" dataKey="id" [paginator]="true" [rows]="20" [selection]="selected()" (selectionChange)="onSelect($event)">
            <ng-template pTemplate="header">
              <tr>
                <th style="width:44px"><p-tableHeaderCheckbox /></th>
                <th>{{ t('sales.regulated.brokerage.fields.accountNumber') }}</th>
                <th>{{ t('sales.regulated.brokerage.fields.suitability') }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td><p-tableCheckbox [value]="row" /></td>
                <td><button type="button" class="link-btn" (click)="openDetail(row.id)">{{ row.accountNumber }}</button></td>
                <td>{{ row.suitabilityApproved ? t('common.yes') : t('common.no') }}</td>
              </tr>
            </ng-template>
          </p-table>
        </section>
      }
    </ain-page>
  `,
  styles: [REGULATED_PANEL_STYLES]
})
export class SalesBrokerageAccountsComponent implements OnInit {
  private readonly api = inject(SalesRegulatedApiService);
  private readonly router = inject(Router);
  private readonly localization = inject(LocalizationService);
  readonly loading = signal(true);
  readonly rows = signal<RegulatedBrokerageAccountListItem[]>([]);
  readonly selected = signal<RegulatedBrokerageAccountListItem[]>([]);
  ngOnInit(): void { this.load(); }
  load(): void {
    this.loading.set(true);
    this.api.listBrokerageAccounts().subscribe({
      next: r => { this.rows.set(r); this.loading.set(false); },
      error: () => { this.rows.set([]); this.loading.set(false); }
    });
  }
  onSelect(v: RegulatedBrokerageAccountListItem[]): void { this.selected.set(v ?? []); }
  openCreate(): void { void this.router.navigate(['/sales/brokerage-accounts/new']); }
  openDetail(id: string): void { void this.router.navigate(['/sales/brokerage-accounts', id]); }
  goOrders(): void { void this.router.navigate(['/sales/brokerage-orders']); }
  t(key: string): string { return this.localization.translate(key); }
}
